import { lazyRetry } from "helpers/lazyRetry";

const Supervision_L = lazyRetry(() => import("./Supervision"));

export default Supervision_L;
